module.exports = __webpack_public_path__ + "static/media/aivishing.cf6230f8.png";